function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { CoralResponse, CoralInterceptor } from "@amzn/ihm-js-coral-client";
import { CSRF_TOKEN_ID } from "../config/externalSiteConstants";
var RequestOptionsInterceptor = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptor, CoralInterceptor1);
    var _super = _create_super(RequestOptionsInterceptor);
    function RequestOptionsInterceptor() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptor);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptor, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns {CoralResponse} response
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                var _sessionStorage_getItem;
                // Adding required header
                var headers = [
                    [
                        "Accept",
                        "application/json"
                    ],
                    [
                        "Content-Type",
                        "application/json"
                    ],
                    [
                        CSRF_TOKEN_ID,
                        (_sessionStorage_getItem = sessionStorage.getItem(CSRF_TOKEN_ID)) !== null && _sessionStorage_getItem !== void 0 ? _sessionStorage_getItem : ""
                    ]
                ];
                var modifiedRequest = request.clone({
                    headers: headers,
                    credentials: "same-origin"
                });
                return from(next.handle(modifiedRequest)).pipe(map(function(response) {
                    var _responseHeaders;
                    var responseHeaders = response.headers;
                    var _responseHeaders_find;
                    var _ref = _sliced_to_array((_responseHeaders_find = (_responseHeaders = responseHeaders) === null || _responseHeaders === void 0 ? void 0 : _responseHeaders.find(function(param) {
                        var _param = _sliced_to_array(param, 1), k = _param[0];
                        return k === CSRF_TOKEN_ID;
                    })) !== null && _responseHeaders_find !== void 0 ? _responseHeaders_find : [
                        CSRF_TOKEN_ID,
                        ""
                    ], 2), csrfToken = _ref[1];
                    // Adding monsCustomerId to session storage for future reference in apis.
                    sessionStorage.setItem(CSRF_TOKEN_ID, csrfToken);
                    return new CoralResponse(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptor;
}(CoralInterceptor);
export default RequestOptionsInterceptor;

//# sourceMappingURL=RequestOptionsInterceptor.js.map